const state = {
  sidebar: {
    opened: true,
    withoutAnimation: false
  },
  device: 'desktop',
  siteName: '',
  copyright: ''
}

const mutations = {
  SET_SITE_NAME(state, name) {
    state.siteName = name || ''
  },
  SET_COPYRIGHT(state, text) {
    state.copyright = text || ''
  },
  TOGGLE_SIDEBAR(state) {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
  },
  CLOSE_SIDEBAR(state, withoutAnimation) {
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE(state, device) {
    state.device = device
  }
}

const actions = {
  setSiteName({ commit }, name) { commit('SET_SITE_NAME', name) },
  setCopyright({ commit }, text) { commit('SET_COPYRIGHT', text) },
  setSiteInfo({ commit }, { site_name, copyright }) {
    if (site_name) commit('SET_SITE_NAME', site_name)
    if (copyright !== undefined) commit('SET_COPYRIGHT', copyright)
  },
  toggleSideBar({ commit }) { commit('TOGGLE_SIDEBAR') },
  closeSideBar({ commit }, { withoutAnimation }) { commit('CLOSE_SIDEBAR', withoutAnimation) },
  toggleDevice({ commit }, device) { commit('TOGGLE_DEVICE', device) }
}

export default { namespaced: true, state, mutations, actions }
